import React, { useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Box from '@mui/material/Box'

import { selectPage, selectPageIsMine } from '../pages/pagesSlice'
import {
  updateDirtyStikisAsync,
  setStikisInMarqueeSelected,
} from './stikisSlice'
import {
  startMarqueeSelect,
  updateMarqueeSelect,
  endMarqueeSelect,
  selectMarqueeIsSelecting,
  selectMarqueeBox,
} from '../ui/uiSlice'

import { pxToEm } from '../../helpers'

export default function MarqueeEventWrapper({ pageId, children }) {
  const dispatch = useDispatch()
  const domRef = useRef(null)

  ///////////////////////////////////////////////
  //
  // Selectors
  //

  const page = useSelector(selectPage(pageId))
  const isMine = useSelector(selectPageIsMine(pageId))
  const marqueeBox = useSelector(selectMarqueeBox)

  // console.log('<MarqueeSelection /> marqueeBox:', marqueeBox)

  ///////////////////////////////////////////////
  //
  // Local state
  //

  const isSelecting = useSelector(selectMarqueeIsSelecting)
  const [hasSelected, setHasSelected] = useState(false)

  ///////////////////////////////////////////////
  //
  // Events
  //

  const handleMouseDown = (e) => {
    // Selecting stikis is the first half of moving them, which a guest can't do.
    if (!isMine) {
      return
    }

    if (e.shiftKey) {
      // console.log('<MarqueeEventWrapper/>.handleMouseDown()')

      // Figure out the marquee start relative to page origin
      const domRect = domRef.current.getBoundingClientRect()
      const startX = e.pageX - domRect.width / 2
      const startY = e.pageY - domRect.height / 2

      dispatch(
        startMarqueeSelect({
          x: pxToEm(startX, page.zoom) - page.left_edge,
          y: pxToEm(startY, page.zoom) - page.top_edge,
        })
      )
      setHasSelected(true)

      e.stopPropagation()
      e.preventDefault()
    }
  }

  const handleMouseMove = (e) => {
    if (isSelecting) {
      // console.log('<MarqueeEventWrapper/>.handleMouseMove()')
      // Figure out the marquee start relative to page origin
      const domRect = domRef.current.getBoundingClientRect()
      const endX = e.pageX - domRect.width / 2
      const endY = e.pageY - domRect.height / 2

      const { left, top } = marqueeBox

      dispatch(
        updateMarqueeSelect({
          x: pxToEm(endX, page.zoom) - page.left_edge,
          y: pxToEm(endY, page.zoom) - page.top_edge,
        })
      )

      e.stopPropagation()
      e.preventDefault()
    }
  }

  const handleMouseUp = (e) => {
    if (isSelecting) {
      // console.log('<MarqueeEventWrapper/>.handleMouseUp()')
      dispatch(
        setStikisInMarqueeSelected({
          pageId,
          marquee: marqueeBox,
          retainSelection: e.shiftKey,
        })
      )
      if (hasSelected) {
        dispatch(updateDirtyStikisAsync(pageId))
      }
      dispatch(endMarqueeSelect())

      setHasSelected(false)
      e.preventDefault()
      e.stopPropagation()
    }
  }

  ///////////////////////////////////////////////
  //
  // Markup
  //

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
      }}
      ref={domRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {children}
    </Box>
  )
}
